import { render, staticRenderFns } from "./ViewChildStoryContributor.vue?vue&type=template&id=13cfd8e8&scoped=true&"
import script from "./ViewChildStoryContributor.vue?vue&type=script&lang=js&"
export * from "./ViewChildStoryContributor.vue?vue&type=script&lang=js&"
import style0 from "./ViewChildStoryContributor.vue?vue&type=style&index=0&id=13cfd8e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cfd8e8",
  null
  
)

export default component.exports